export default __webpack_public_path__ + "static/11-13 Editorial-07ad22c882ba506009414adc5f6ea9e0.pdf";